function fallbackDownloadCanvas(canvas, filename) {
    const link = document.createElement('a');
    link.download = filename;
    link.href = canvas.toDataURL('image/png');
    link.click();
}

export async function shareOrDownloadCanvas(canvas, filename, title, text) {
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
    if (!blob) {
        fallbackDownloadCanvas(canvas, filename);
        return;
    }

    const file = new File([blob], filename, { type: 'image/png' });
    if (navigator.share && navigator.canShare?.({ files: [file] })) {
        try {
            await navigator.share({ files: [file], title, text });
            return;
        } catch (e) {
            if (e?.name === 'AbortError') return;
        }
    }
    fallbackDownloadCanvas(canvas, filename);
}
